<form class="search-filters__form"
  fxFlex
  fxLayout="column"
  name="searchForm">
  <div class="search-filters__container"
    fxFlex="1 1 100"
    fxLayout="row wrap"
    fxLayoutAlign="start center"
    fxLayoutGap="24px">
    @for (field of fieldsFormatedForDirective; track field) {
      @if (field==='type') {
        <mat-form-field [floatLabel]="floatLabel">
          <!--TODO replace 'projects-management.lesson_space' by a value coming form input because it could have two value-->
          <mat-label>{{ getFieldTerms('type') !== '' ? (getFieldTerms('type') | translate) : ('generic.type_global_corpus' | translate) }}</mat-label>
          <mat-select name="typeFilter"
            [formControl]="controls['typeFilter'].formControl">
            <mat-option value="all">
              @if (displayedFiltersIcons) {
                <mat-icon svgIcon="allTypes" title="audio"></mat-icon>
              }
              {{ 'generic.all' | translate }}
            </mat-option>
            @for (type of customLists['types']; track type) {
              <mat-option [value]="type.id" appAriaTitle>
                @if (type.id === 'audio') {
                  <span>@if (displayedFiltersIcons) {
                    <mat-icon svgIcon="audio"
                    title="audio"></mat-icon>
                  }
                {{ 'generic.audio' | translate }}</span>
              }
              @if (type.id === 'document') {
                <span>@if (displayedFiltersIcons) {
                  <mat-icon svgIcon="document"
                  title="audio"></mat-icon>
                }
              {{ 'generic.document' | translate }}</span>
            }
            @if (type.id === 'image') {
              <span>@if (displayedFiltersIcons) {
                <mat-icon svgIcon="image"
                title="audio"></mat-icon>
              }
            {{ 'generic.image' | translate }}</span>
          }
          @if (type.id === 'media') {
            <span>@if (displayedFiltersIcons) {
              <mat-icon svgIcon="media"
              title="audio"></mat-icon>
            }
          {{ 'generic.media' | translate }}</span>
        }
        @if (type.id === 'text') {
          <span>@if (displayedFiltersIcons) {
            <mat-icon svgIcon="text"
            title="audio"></mat-icon>
          }
        {{ 'generic.text' | translate }}</span>
      }
      @if (type.id === 'url') {
        <span>@if (displayedFiltersIcons) {
          <mat-icon svgIcon="url"
          title="audio"></mat-icon>
        }
      {{ 'generic.url' | translate }}</span>
    }
    @if (type.id === 'video') {
      <span>@if (displayedFiltersIcons) {
        <mat-icon svgIcon="video"
        title="audio"></mat-icon>
      }
    {{ 'generic.video' | translate }}</span>
  }
</mat-option>
}
</mat-select>
</mat-form-field>
}
<!--TODO replace generic.title by a value coming form input because it could have multiple value-->
@if (field==='title') {
  <mat-form-field class="filters-field-title" [floatLabel]="floatLabel">
    <mat-label>{{ getFieldTerms('title') !== '' && getFieldTerms('title') !== 'generic.title' ? (getFieldTerms('title') | translate) : defaultFieldTitle }}</mat-label>
    <input #titleInput="matInput" matInput [formControl]="controls['titleFilter'].formControl"
      data-e2e="search-filter-title"
      >
    </mat-form-field>
  }
  @if (field==='metadatas_title') {
    <mat-form-field class="filters-field-metadatas_title" [floatLabel]="floatLabel">
      <mat-label>{{ getFieldTerms('metadatas_title') !== '' && getFieldTerms('title') !== 'generic.title' ? (getFieldTerms('metadatas_title') | translate) : defaultFieldTitle }}</mat-label>
      <input #titleInput="matInput" matInput [formControl]="controls['metadatas_title'].formControl"
        data-e2e="search-filter-metadata-title"
        >
      </mat-form-field>
    }
    @if (field==='skills') {
      <mat-form-field class="filters-field-skills" [floatLabel]="floatLabel">
        <mat-label>{{ 'generic.skills' | translate }}</mat-label>
        <mat-select
          name="searchSkillsFilter"
          [formControl]="controls['searchSkillsFilter'].formControl"
          >
          <mat-option appAriaTitle [value]="'all'">{{ 'generic.all' | translate }}</mat-option>
          @for (skills of dataLists['skills']; track skills) {
            <mat-option appAriaTitle [value]="skills.id">
              <span>{{ skills.get('label') }}</span>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (field==='difficulty') {
      <mat-form-field class="filters-field-difficulty" [floatLabel]="floatLabel">
        <mat-label>{{ 'generic.difficulty' | translate }}</mat-label>
        <mat-select name="difficultyFilter"
          [formControl]="controls['difficultyFilter'].formControl">
          <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
          @for (difficulty of dataLists['difficulty']; track difficulty) {
            <mat-option appAriaTitle [value]="difficulty.id">
              {{ difficulty.get('label') }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (field==='usage') {
      <mat-form-field class="filters-field-usage" [floatLabel]="floatLabel">
        <mat-label>{{ 'generic.usage' | translate }}</mat-label>
        <mat-select name="difficultyFilter"
          [formControl]="controls['usageFilter'].formControl">
          <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
          @for (usage of dataLists['usage']; track usage) {
            <mat-option appAriaTitle [value]="usage.id">
              {{ (usage.get('label') | translate) }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (field==='educationnalLevel' && !displayField('educationnalLevel-toogle')) {
      <mat-form-field class="filters-field-educationnalLevel"  [floatLabel]="floatLabel">
        <mat-label>{{ 'generic.level' | translate }}</mat-label>
        <mat-select name="educationnalLevelFilter"
          [formControl]="controls['educationnalLevelFilter'].formControl">
          <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
          @for (level of dataLists['educational_level']; track level) {
            <mat-option appAriaTitle [value]="level.id">
              {{ level.get('label') }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (field==='method') {
      <mat-form-field class="filters-field-method" [floatLabel]="floatLabel">
        <mat-label>{{ 'licensing.method' | translate }}</mat-label>
        <mat-select name="licenseFilter" [formControl]="controls['licenseFilter'].formControl"
          >
          <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
          @for (method of customLists['methods']; track method) {
            <mat-option appAriaTitle [value]="method.id">
              {{ method.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (field==='chapters' && !displayField('chapters-toogle')) {
      <mat-form-field
        class="search-filters__chapter-field filters-field-chapters" [floatLabel]="floatLabel">
        <mat-label>{{ 'generic.chapters' | translate }}</mat-label>
        <mat-select name="chaptersFilter"
          [formControl]="controls['chaptersFilter'].formControl">
          <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
          @for (chapters of dataLists['chapters']; track chapters) {
            <mat-option appAriaTitle
              [value]="chapters.id">
              {{ chapters.get('label') }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    <!-- This version use button list whith only one choice possible -->
    @if (field==='chapters-toogle') {
      <div
        class="search-filters__chapter-toggle filters-field-chapters">
        <mat-button-toggle-group class="search-filters__toggle-group"
          name="chaptersFilter"
          hideSingleSelectionIndicator="true"
          [formControl]="controls['chaptersFilter'].formControl">
          @for (chapter of dataLists['chapters']; track chapter; let index = $index) {
            <mat-button-toggle
              class="search-filters__toggle-button-wrapper exclude-elem-to-order-directive"
              [class.selected]="controls['chaptersFilter'].formControl.value === chapter.id"
              [class.search-filters__toggle-button-wrapper--selected]="controls['chaptersFilter'].formControl.value === chapter.id"
              [value]="chapter.id"
              (click)="launchSearch()"
              data-e2e="search-filters-lanch-search-155">
              {{ chapter.get('label') }}
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>
    }
    @if (field==='concepts') {
      <mat-form-field class="filters-field-concepts" [floatLabel]="floatLabel">
        <mat-label>{{ 'generic.concepts' | translate }}</mat-label>
        <mat-select name="conceptsFilter"
          [formControl]="controls['conceptsFilter'].formControl">
          <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
          @for (concepts of dataLists['concepts']; track concepts) {
            <mat-option appAriaTitle [value]="concepts.id">
              {{ concepts.get('label') }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (field==='thematics') {
      <mat-form-field class="filters-field-thematics" [floatLabel]="floatLabel">
        <mat-label>{{ 'generic.thematics' | translate }}</mat-label>
        <mat-select name="thematicsFilter"
          [formControl]="controls['thematicsFilter'].formControl">
          <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
          @for (thematics of dataLists['thematics']; track thematics) {
            <mat-option appAriaTitle [value]="thematics.id">
              {{ thematics.get('label') }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (field==='notions') {
      <mat-form-field class="filters-field-notions" [floatLabel]="floatLabel">
        <mat-label>{{ 'generic.notions' | translate }}</mat-label>
        <mat-select name="notionsFilter"
          [formControl]="controls['notionsFilter'].formControl">
          <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
          @for (notions of dataLists['notions']; track notions) {
            <mat-option appAriaTitle [value]="notions.id">
              {{ notions.get('label') }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (field==='assignation_type') {
      <mat-form-field class="filters-field-assignation_type" [floatLabel]="floatLabel">
        <mat-label>{{ 'generic.type' | translate }}</mat-label>
        <mat-select name="assignation_typeFilter"
          [formControl]="controls['assignation_typeFilter'].formControl">
          <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
          @for (assignation_type of dataLists['assignation_type']; track assignation_type) {
            <mat-option appAriaTitle
              [value]="assignation_type.id">
              {{ localizedType(assignation_type.get('label')) | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (field==='schoolyears') {
      <mat-form-field class="filters-field-schoolyears" [floatLabel]="floatLabel">
        <mat-label>{{ 'groups-management.chose_school.year' | translate }}</mat-label>
        <mat-select name="schoolyearsFilter" [formControl]="controls['schoolyearsFilter'].formControl"
          >
          <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
          @for (shoolyear of dataLists['schoolyears']; track shoolyear) {
            <mat-option appAriaTitle
              [value]="shoolyear.id">{{ displaySchoolYear(shoolyear.get('name')) }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (field==='lessons') {
      <mat-form-field class="filters-field-lessons" [floatLabel]="floatLabel">
        <mat-label>{{ 'generic.lessons' | translate }}</mat-label>
        <mat-select name="lessonsFilter" [formControl]="controls['lessonsFilter'].formControl"
          >
          <mat-option appAriaTitle [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
          @for (lesson of customLists['lessons']; track lesson) {
            <mat-option appAriaTitle [value]="lesson.id">
              {{ lesson.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    <!--author is also use for theme todo field name placeholder -->
    @if (field==='author') {
      <mat-form-field class="filters-field-author" [floatLabel]="floatLabel">
        <mat-label>{{ getFieldTerms('author') !== '' ? (getFieldTerms('author') | translate) : ('generic.author_global_corpus' | translate) }}</mat-label>
        <input matInput [formControl]="controls['authorFilter'].formControl"
          data-e2e="search-filter-author"
          >
        </mat-form-field>
      }
      <!--group is also use for niveau todo field name placeholder-->
      @if (field==='group') {
        <mat-form-field class="filters-field-group" [floatLabel]="floatLabel">
          <mat-label>{{ getFieldTerms('group') !== '' ? (getFieldTerms('group') | translate) : ('generic.group_global_corpus' | translate) }}</mat-label>
          <input matInput [formControl]="controls['groupFilter'].formControl"
            data-e2e="search-filter-group"
            >
          </mat-form-field>
        }
        @if (field==='launchSearch') {
          <button class="search-filters__search-button filters-field-launchSearch"
            data-e2e="search-filters-lanch-search-246"
            (click)="launchSearch()">
            {{ 'generic.search' | translate }}
          </button>
        }
        @if (field==='countEntities') {
          <span
            class="filters-field-countEntities"
            fxlayout="row"
            fxlayoutalign="start center">
            {{ countEntities }} {{ (countEntities < 2 ? 'generic.result' : 'generic.results') | translate }}
          </span>
        }
        @if (field==='bookmarks') {
          <mat-checkbox
            class="search-filters__bookmark-checkbox filters-field-bookmarks"
            name="filterBookmarks"
            [formControl]="controls['searchBookmarkFilter'].formControl"
            (change)="launchSearch()">
            {{ 'generic.filter_by_bookmarks' | translate }}
          </mat-checkbox>
        }
        @if (field==='autocorrection') {
          <mat-checkbox
            class="search-filters__autocorrect-checkbox"
            name="filterAutocorrection"
            [formControl]="controls['searchAutocorrectionFilter']?.formControl"
            (change)="launchSearch()">
            {{ 'generic.filter_by_autocorrection' | translate }}
          </mat-checkbox>
        }
      }
    </div>
  </form>
